/**
 * CareerUpdated.contract.ts — Event Contract System™ (generation v1).
 * DOMAIN INTEGRATION HARDENING sprint: published by the Career Domain Service
 * whenever any Career™-owned data changes (income, companies). Coarse-grained
 * "something in the domain changed" signal for dashboards and summaries.
 */

import type { EventContract } from '../EventContractRegistry';

export const CareerUpdatedContract: EventContract = {
  name: 'CareerUpdated',
  version: 1,
  description: 'Career™ domain data changed (income or companies). Published by the Career Domain Service after every successful mutation.',
  publishers: ['career-domain'],
  subscribers: ['income-page', 'companies-page', 'devcenter', 'module:wallet'],
  fields: [
    { name: 'aspect', type: 'string', required: true, description: "Which slice changed: 'income' | 'companies'" },
    { name: 'action', type: 'string', required: true, description: "What happened: 'created' | 'updated' | 'deleted' | 'migrated'" },
  ],
  allowExtraFields: true,
  timestampPolicy: 'Publish time (Date.now()) when the mutation succeeds against the API layer.',
  stability: 'stable',
  deprecated: false,
  example: { aspect: 'income', action: 'created' },
};
